<template lang="pug">
    div#about
        Header
        div.row.cf__about
            div.container
                div.infoBlock
                    h2.titleBlock О нас
                    div.text
                        p Горско-еврейский (джуури, джухури) — родной язык горских евреев Восточного Кавказа, особенно Азербайджана и Дагестана, а также Кабардино-Балкарии.
                        p В настоящее время горско-еврейский язык распространён в районе города Губа (Азербайджан), в Дербенте и некоторых других населённых пунктах Дагестана, в Нальчике, Москве и других крупных городах России. При этом считается, что большинство говорящих на джуури ныне проживает в Израиле. Есть носители языка также в США, Канаде, Германии. Практически все говорящие на джуури владеют и другими языками стран проживания.
                        p Данный проект является бесплатным и, в первую очередь, направлен на поддержание целостности и актуальности горско-еврейского языка.
                        p База слов постоянно пополняется нашими модераторами. Также, любой желающий может добавить слово, тем самым внеся свой вклад в развитие приложения.
                        p Выражаем отдельную благодарность проекту Алефби за помощь в создании данного проекта!
                        p Спасибо за то, что пользуютесь нашим сайтом!
                //infoBlock
            //container
        //cf__about
</template>

<script>
    import Header from '@/components/Header.vue'
    export default {
        name: 'about',
        components: {
            Header
        },
    }
</script>
